<form [formGroup]="editorFormGroup"
      *ngrxLet="params$; let params;"
      [style.width.px]="params?.eGridCell?.clientWidth"
      [ngClass]="{ 'border-[#D62D1A]': editorFormGroup.invalid && editorFormGroup.touched }"
      cdkTrapFocus>
  <mat-form-field
      appearance="fill"
      floatLabel="always"
      class="textFormField">
    <!--    strangely, appGxInput does not suffice here to hide 1passowrd button, that's why there's
    the 'data-1p-ignore' attribute
    https://1password.community/discussion/117501/as-a-web-developer-how-can-i-disable-1password-filling-for-a-specific-field/p3-->
    <textarea
        #textInput
        class="textarea"
        data-1p-ignore
        matInput
        appGxInput
        appDblClickPrependToday
        [placeholder]="params?.colDef?.headerName"
        cdkTextareaAutosize
        cdkAutosizeMaxRows="15"
        cdkAutosizeMinRows="3"
        [formControlName]="params?.colDef?.field"></textarea>

    @if (getNewFieldValue()?.length) {
      <div class="copyIcon"
           (click)="copyTextInput(textInput)">
        <mat-icon svgIcon="content_copy"></mat-icon>
      </div>
    }

    @if (editorFormGroup.invalid) {
      <mat-error
          class="flex items-center"
          [matTooltip]="getErrorMessage(params)">
        <mat-icon svgIcon="error" class="errorIcon"></mat-icon>
        <span class="truncate">{{getErrorMessage(params)}}</span>
      </mat-error>
    }
  </mat-form-field>
</form>